import OldTimeTablePage from "./OldTimeTablePage";

export default OldTimeTablePage;
